//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex'
import Rater from 'vux/src/components/rater/index.vue'
import MyRater from '@/components/rater/rater.vue'
import sliderItem from '@/components/slider/slider.vue'
import downloadImgs from '@/mixins/downloadImgs'
export default {
  mixins: [downloadImgs],
  data() {
    return {
      isHistory: false,
      rule: {
        custom: {
          validateValue: {
            required: () => '请打分',
          },
        },
      },
    }
  },
  props: {
    question: {
      type: Object,
      default() {
        return {}
      },
    },
    index: {
      type: Number,
    },
    readonly: {
      type: Boolean,
    },
    showScore: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    Rater,
    MyRater,
    sliderItem,
  },
  created() {
    // matrixScaleId
    this.question.children.forEach((i) => {
      this.$set(i, '$index', 0)
    })
  },
  mounted() {
    this.filterHistory()
    this.$validator.localize('zh_CN', this.rule)
    if (this.question.v_answer) {
      let maps = {}
      this.question.v_answer.options.forEach((i) => {
        maps[`${i.tenantId}`] = i.matrixScaleId
      })
      this.question.children.forEach((i) => {
        i.$index =
          this.question.options.findIndex((option) => {
            return maps[`${i.tenantId}`] === option.tenantId
          }) + 1
      })
    }
  },
  computed: {
    ...mapGetters(['questionnaireList']),
    currentLevel() {
      return Number(this.question.level)
    },
    validateValue() {
      let isFull = this.question.children.every((i) => {
        return i.$index > 0
      })
      return isFull ? 'pass' : ''
    },
    total() {
      return this.question.children.reduce((prev, cur) => {
        return prev + cur.$index
      }, 0)
    },
    icon() {
      let iconfont = 'xingxing'
      switch (this.question.style) {
        case 'star':
          iconfont = 'xingxing'
          break
        case 'heart':
          iconfont = 'heart'
          break
        case 'smile':
          iconfont = 'smile'
          break
        case 'like':
          iconfont = 'dianzan'
          break
        default:
          iconfont = 'xingxing'
      }
      return `<span class="iconfont icon-${iconfont}" style="font-size: 20px"></span>`
    },
  },
  watch: {
    total(n) {
      const param = {
        index: this.index,
        v_answered: !!n,
      }
      let v_answer = {
        options: [],
      }
      // 设置当前题目已答
      this.$store.commit('setQuestionAnswered', param)
      if (!param.v_answered) {
        this.$store.commit('setQusstionUserAnswer', {
          index: this.index,
          v_answer,
        })
        // 取消回调
        this.$emit('onSelectCancel')
        return
      }

      v_answer = this.getValue()
      //挂本道题用户答案
      this.$store.commit('setQusstionUserAnswer', {
        index: this.index,
        v_answer,
      })
    },
  },
  methods: {
    filterHistory() {
      if (this.question.optionTag != 100) {
        let isHistory = false
        let his1 = false
        let his2 = false
        let his3 = false
        let len = this.question.options.length
        this.question.options.forEach((item, i) => {
          if (item.text == '2' && i == 1) {
            his1 = true
          }
          if (item.text == '3' && i == 2) {
            his2 = true
          }
          if (item.text == '4' && i == 3) {
            his3 = true
          }
        })
        if (len == 3) {
          isHistory = his1
        } else if (len == 4) {
          isHistory = his2
        } else if (len == 5) {
          isHistory = his3
        } else {
          isHistory = his1 && his2 && his3
        }
        this.isHistory = isHistory
      }
    },
    getValue() {
      // 查找问题答案
      let options = []
      this.question.children.forEach((i) => {
        if (i.$index) {
          options.push({
            matrixScaleId: this.question.options[i.$index - 1].tenantId,
            tenantId: i.tenantId,
          })
        }
      })
      return {
        tenantId: this.question.tenantId,
        type: 'matrix_scale',
        options: options,
      }
    },
    validate() {
      return this.$validator.validate()
    },
  },
}
